import React, { useState } from 'react';
import { api } from '../api';

export default function ProfilePage({ user }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleChangePassword(e) {
    e.preventDefault();
    setMessage('');
    setError('');

    if (newPassword.length < 6) {
      setError('Новый пароль должен быть не менее 6 символов');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      await api.changePassword(currentPassword, newPassword);
      setMessage('Пароль успешно изменён');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="profile-page">
      <h2>Профиль</h2>
      <div style={{ marginBottom: 24, color: 'var(--text2)' }}>
        <p><strong style={{ color: 'var(--text)' }}>{user.name}</strong></p>
        <p>{user.email}</p>
        <p style={{ marginTop: 4 }}>Роль: <span className={`badge ${user.role}`}>{user.role}</span></p>
      </div>

      <h3 style={{ marginBottom: 16 }}>Сменить пароль</h3>
      <form className="profile-form" onSubmit={handleChangePassword}>
        <div>
          <label>Текущий пароль</label>
          <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} required />
        </div>
        <div>
          <label>Новый пароль</label>
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required />
        </div>
        <div>
          <label>Подтвердите новый пароль</label>
          <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
        </div>
        {error && <div className="error-msg">{error}</div>}
        {message && <div className="success-msg">{message}</div>}
        <button type="submit" disabled={loading}>{loading ? 'Сохранение...' : 'Сменить пароль'}</button>
      </form>
    </div>
  );
}
